import React, { useState } from "react";
import {
  Dropdown,
  DropdownMenu,
  DropdownItem,
  DropdownToggle,
} from "reactstrap";
import * as FontawesomeSolid from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { hasPermission } from "utility/helpers";
import { useLocation, useNavigate } from "react-router";
import {
  ACCOUNT_AGENCY,
  HIDDEN_REPRESENTATIVES_VIEW,
  DIRECTORY_VIEW,
  HIDDEN_PROGRAMS_VIEW,
  HIDDEN_AFFILIATIONS_VIEW,
  SUPER_ADMIN_ACCOUNTS,
  congRoles,
  ACCOUNTS_VIEW,
} from "utility/constants";
import styled from "styled-components";
import useAuth from "hooks/useAuth";
import { AGENCY_TESDA } from "constants/agency";
import { VIEW_ACTION } from "constants/actions";

const BurgerWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-self: flex-end;

  svg {
    color: ${({ isHomePage }) => (isHomePage ? "white" : "black")};
  }
`;

const hasTVIPermission = (user) => {
  const { type, agency } = user;

  if (SUPER_ADMIN_ACCOUNTS.includes(type)) {
    return true;
  }

  if (type === ACCOUNT_AGENCY && agency === AGENCY_TESDA) {
    return true;
  }

  return false;
};

const getDropdownItems = (user) => {
  const role = user?.type;
  const cong = user?.congressman;

  return [
    {
      label: "Home",
      showItem: hasPermission("landing"),
      link: "/home",
    },
    {
      label: "Home",
      showItem: congRoles.includes(role),
      link: `/representatives/${cong?.region?.id}/cong/${cong?.id}`,
    },
    {
      label: "Representatives",
      showItem: !HIDDEN_REPRESENTATIVES_VIEW.includes(role),
      link: "/representatives",
    },
    {
      label: "Programs",
      showItem: !HIDDEN_PROGRAMS_VIEW.includes(role),
      link: "/projects",
    },
    {
      label: "Affiliation",
      showItem: !HIDDEN_AFFILIATIONS_VIEW.includes(role),
      link: "/parties",
    },
    {
      label: "Directory",
      showItem: DIRECTORY_VIEW.includes(role),
      link: "/directory",
    },
    {
      label: "Events",
      showItem: hasPermission("event-view"),
      link: "/events",
    },
    {
      label: "Committee",
      showItem: hasPermission("membership-committee-view"),
      link: "/committee",
    },
    {
      label: "Send Request",
      showItem: hasPermission("project-create"),
      link: "/add-project",
    },
    {
      label: "Accounts",
      showItem: ACCOUNTS_VIEW.includes(role),
      link: "/accounts",
    },
    {
      label: "Profile",
      link: "/account",
      additionalParams: {
        state: {
          action: VIEW_ACTION,
        },
      },
    },
    {
      label: "Summary Reports",
      showItem:
        hasPermission("summary-view") || hasPermission("summary-daily-view"),
      link: "/summary",
    },
    {
      label: "Utilization Reports",
      showItem: hasPermission("utilization-view"),
      link: "/utilization",
    },
    {
      label: "News",
      showItem: hasPermission("news-view"),
      link: "/news",
    },
    {
      label: "Logs",
      showItem: hasPermission("logs-view"),
      link: "/logs",
    },
    {
      label: "TVI Settings",
      showItem: hasTVIPermission(user),
      link: "/settings/tesda",
    },
  ];
};

const UserDropdown = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const { user } = useAuth();

  const [collapsed, setCollapsed] = useState(false);

  const toggleNavbar = () => setCollapsed(!collapsed);

  const isHomePage = location.pathname === "/home" || location.pathname === "/";

  if (!user) return null;

  return (
    <BurgerWrapper isHomePage={isHomePage}>
      <Dropdown
        isOpen={collapsed}
        toggle={toggleNavbar}
      >
        <DropdownToggle
          tag="a"
          className="nav-link"
        >
          <FontAwesomeIcon
            icon={FontawesomeSolid.faBars}
            size="xl"
          />
        </DropdownToggle>

        <DropdownMenu end>
          {getDropdownItems(user).map(
            ({ label, link, showItem = true, additionalParams }, index) =>
              showItem && (
                <DropdownItem
                  // eslint-disable-next-line react/no-array-index-key
                  key={index}
                  onClick={() => {
                    navigate(link, additionalParams);
                  }}
                >
                  {label}
                </DropdownItem>
              )
          )}
          <DropdownItem divider />
          <DropdownItem
            tag="a"
            href="/logout"
          >
            {"Logout"}
          </DropdownItem>
        </DropdownMenu>
      </Dropdown>
    </BurgerWrapper>
  );
};

export default UserDropdown;
